module.exports = __webpack_public_path__ + "img/background-gallery-details.b129109f.jpg";